import { Skeleton } from '@zoopla-eng/zds-components/skeleton';
import { Box } from '@zoopla-eng/zds-components/box';

import {
    skeletonAddressStyles,
    skeletonCardStyles,
    skeletonDetailsWrapperStyles,
    skeletonImageStyles,
    skeletonPOIStyles,
    skeletonTitleStyles,
    skeletonTitleWrapperStyles
} from './SimilarListingCardSkeleton.css';

interface SimilarListingCardSkeletonProps {
    className?: string;
}

export const SimilarListingCardSkeleton = ({
    className
}: SimilarListingCardSkeletonProps) => (
    <Skeleton.Root loadingText="Loading">
        <div
            className={`${skeletonCardStyles}${
                className ? ` ${className}` : ''
            }`}
        >
            <div className={skeletonImageStyles}>
                <Skeleton.Wave />
            </div>
            <div className={skeletonDetailsWrapperStyles}>
                <div className={skeletonTitleWrapperStyles}>
                    <div className={skeletonTitleStyles}>
                        <Skeleton.Text />
                    </div>
                </div>

                <div className={skeletonPOIStyles}>
                    <Skeleton.Text />
                    <Skeleton.Text />
                    <Skeleton.Text />
                </div>
                <Box pb="S300">
                    <Skeleton.Text />
                </Box>
                <div className={skeletonAddressStyles}>
                    <Skeleton.Text />
                </div>
            </div>
        </div>
    </Skeleton.Root>
);
